import CryptoJS from 'crypto-js';

import { InjectionToken, Provider } from '@angular/core';

import { Ticket } from './ticket.model';

/**
 * Llave con la que se cifra el QR. Es un contrato con el lector del conductor, que descifra en el
 * teléfono (`scan-driver.page.ts`, `driver-reader.page.ts`): con otra llave, el boleto no se puede escanear.
 */
export const TICKET_QR_KEY = new InjectionToken<string>('TICKET_QR_KEY');

export function provideTicketQr(key: string): Provider {
  return { provide: TICKET_QR_KEY, useValue: key };
}

/**
 * El texto que lee el conductor: `transportec-{t|s}|usuario|boleto|fecha local|`, cinco partes al separar por
 * `|`. Una suscripción usa `s`. Mismo formato que `ticket.page.ts` de Movilidad, que sigue teniendo el suyo
 * hasta migrar: un cambio aquí se aplica en los dos lados.
 */
export function ticketQrPayload(ticket: Pick<Ticket, 'id' | 'method'>, userId: number, now: Date): string {
  const offsetMs = now.getTimezoneOffset() * 60_000;
  const local = new Date(now.getTime() - offsetMs).toISOString().slice(0, 19).replace('T', ' ');
  const kind = ticket.method && ticket.method !== 'subscription' ? 't' : 's';
  return `transportec-${kind}|${userId}|${ticket.id}|${local}|`;
}

export function buildTicketQr(ticket: Pick<Ticket, 'id' | 'method'>, userId: number, key: string, now = new Date()): string {
  return CryptoJS.AES.encrypt(ticketQrPayload(ticket, userId, now), key).toString();
}
